// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iAg8p","left":"styles_left__19Y8y"};